import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SubProject } from 'src/app/model/project/sub-project';
import { AbstractClientProjectsComponent } from '../abstract-client-projects/client-projects.component';

@Component({
  selector: 'repo-projects',
  templateUrl: '../../projects-table/projects-table.component.html',
  styleUrls: ['../../projects-table/projects-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RepoProjectsComponent extends AbstractClientProjectsComponent
  implements OnInit {
  ngOnInit() {
    super.ngOnInit();
    this.projects = [];
    this.displayedColumns = [
      'project_id',
      'requestor',
      'currentExecutionDate',
      'projectPlacement.address',
      'productType',
      'productSize',
      'mostRecentAdjustmentPhoto',
      'displayStatus'
    ];
    this.fixedSubProjectTypeLabel = 'Weggehaald';
    this.fixedSubProjectTypeClass = 'weghalen';
  }

  // Override
  protected preProcessProjects(projects: SubProject[]): void {
    if (projects == null) {
      return;
    }
    super.preProcessProjects(projects);
    projects.forEach(sp => {
      if (sp.project != null && sp.project.currentExecutionDate != null) {
        sp.currentExecutionDate = sp.project.currentExecutionDate;
      }
    });
  }

  // Override
  protected getTableUrl() {
    return (
      '/subprojects/status-client-repo/Uitgevoerd,Te_factureren,Gearchiveerd/' +
      this.clientCompanySelectService.getSelectedCompanyId()
    );
  }

  // Override
  protected addExtraRouterCommands(
    subProject: SubProject,
    commands: any[]
  ): void {
    commands.push('Repo');
  }

  // Override
  public getDefaultSort() {
    return 'currentExecutionDate';
  }

  // Override
  public getDefaultSortDirection() {
    return 'desc';
  }
}
